/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EMessageType = 'Public' | 'Private' | 'Customer' | 'Template';

export const EMessageType = {
    Public: 'Public' as EMessageType,
    Private: 'Private' as EMessageType,
    Customer: 'Customer' as EMessageType,
    Template: 'Template' as EMessageType
};

